<template>
	<a-modal v-model="show" title="库存报表" :width="700" @ok="doSubmit" @cancel="_close" centered destroyOnClose>
		<a-form-model ref="formRef" :model="formData" :rules="formRule">
			<a-row :gutter="15">
				<a-col span="12">
					<a-form-model-item label="选择类型" prop="type">
						<a-select v-model="formData.type">
							<a-select-option value="">库存表</a-select-option>
							<a-select-option value="true">入库表</a-select-option>
							<a-select-option value="false">出库表</a-select-option>
						</a-select>
					</a-form-model-item>
				</a-col>
				<a-col span="12">
					<a-form-model-item label="选择月份" prop="date">
						<a-month-picker valueFormat="yyyy-MM" v-model="formData.date" placeholder="选择月份"></a-month-picker>
					</a-form-model-item>
				</a-col>
			</a-row>
		</a-form-model>
	</a-modal>
</template>

<script>
import request from '@/config/request';
import utils from '@/common/utils';
import apiUtil from '@/common/apiUtil';
import upImg from '@/components/common/upImg.vue';
import editor from '@/components/component/editor.vue';
import ExporttoExcel from '@/common/ExportExcel.js';
export default {
	components: { upImg, editor },
	data() {
		return {
			show: false,
			status: true,
			loading: false,
			categoryList: [],
			formData: {
				type: '',
				date: ''
			},
			formRule: {
				date: [{ required: true, message: '请选择月份', trigger: 'change' }]
			}
		};
	},
	methods: {
		...apiUtil,
		_show(data) {
			this.show = true;
		},
		_close() {
			this.$refs.formRef.resetFields();
			this.show = false;
			this.$emit('success');
		},
		doSubmit() {
			this.$refs.formRef.validate(valid => {
				if (valid) {
					console.log(this.formData);
                    let name = `${this.formData.date}积分物品${this.formData.type == '' ? '库存表' : (this.formData.type=='true'?'入库表':'出库表')}`;
					console.log(name)
					this.loading = true;
					request.get('/platform/reward/store/rewardGoodsInventory', this.formData).then(res => {
						this.loading = false;
						if(res.data=='' || res.data.length==0){
                            return utils.error('暂无数据')
                        }
                       const filterData = res.data.map(item => {
							return {
								商品名称: item.productName,
								分类名称: item.categoryName,
								类型: item.type?'入库':'出库',
								单价: item.price,
								数量: item.number,
								总价: item.totalMoney,
								时间: item.createTime,
								备注: item.remark
							};
						});
						ExporttoExcel(filterData, `${name}.xlsx`);
					});
				}
			});
		}
	}
};
</script>

<style scoped>
.demo-drawer-footer {
	width: 100%;
	position: absolute;
	bottom: 0;
	left: 0;
	border-top: 1px solid #e8e8e8;
	padding: 10px 16px;
	text-align: right;
	background: #fff;
}
</style>
